export default __webpack_public_path__ + "static/media/auqui4.98bfc807.jpg";